export class Serie {
  _id: string;
  name: string = '';
  slug: string = '';
  image: string = '';
  banner: string = '';
  description: string = '';
  active: boolean = false;
  created: Date;
  updated: Date;
}


// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/series/shared/serie.model.ts